import type { Invoice } from "@medplum/fhirtypes";

import { SERVICE_PAYER_CODE, type ServicePayerCode } from "@/billing/constants/service-payer-code";
import { Extensions } from "@/fhir/enums/extensions";

/**
 * Who a statement bills, read from its service-payer extension.
 *
 * @param invoice The statement to read.
 * @returns The service payer code, or undefined when the extension is absent or holds an unknown code.
 */
export function getInvoiceServicePayerCode(invoice: Invoice): ServicePayerCode | undefined {
  const value = invoice.extension?.find(
    (extension) => extension.url === Extensions.ServicePayer,
  )?.valueString;

  return isServicePayerCode(value) ? value : undefined;
}

function isServicePayerCode(value: string | undefined): value is ServicePayerCode {
  return (Object.values(SERVICE_PAYER_CODE) as string[]).includes(value ?? "");
}
